import { BaseElement, defineElement } from '@webtides/element-js';

/**
 * @property {string} name
 */
export default class TabPanel extends BaseElement {
    properties() {
        return {
            name: undefined,
        };
    }

    connected() {
        // Accessibility
        this.setAttribute('role', 'tabpanel');
        this.setAttribute('id', `tab-panel-${this.name}`);
        this.setAttribute('aria-labelledby', `tab-link-${this.name}`);
    }
}

defineElement('tab-panel', TabPanel);
